import React from "react";
import { TrashIcon, ArchiveBoxIcon } from "@heroicons/react/24/outline";
import Button from "../../../componentLibrary/Button";
import { PageI } from "../../../types";
import { renderPageComponents } from "../../CreateLessonPage/utils/renderComponent";

interface PagePreviewProps {
  page: PageI;
  onDeleteClick: (type: "page", id: string, title: string) => void;
  onArchiveClick?: (pageId: string) => void;
  isArchiving?: boolean;
}

const PagePreview: React.FC<PagePreviewProps> = ({
  page,
  onDeleteClick,
  onArchiveClick,
  isArchiving,
}) => {
  return (
    <div className="h-full flex flex-col">
      {/* Sticky header with action buttons */}
      <div className="flex items-center justify-between pb-4 border-b flex-shrink-0">
        <div>
          <h3 className="text-xl font-semibold">
            {page.title || "Untitled Page"}
          </h3>
          <p className="text-sm text-gray-500">
            {page.components?.length || 0} components
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {onArchiveClick && (
            <Button
              variant="secondary"
              onClick={() => onArchiveClick(page._id!)}
              className="flex items-center gap-2"
              disabled={isArchiving}
              loading={isArchiving}
            >
              <ArchiveBoxIcon className="w-5 h-5" />
              Archive
            </Button>
          )}
          <Button
            variant="cautionary"
            onClick={() =>
              onDeleteClick("page", page._id!, page.title || "Untitled Page")
            }
            className="flex items-center gap-2"
          >
            <TrashIcon className="w-5 h-5" />
            Delete
          </Button>
        </div>
      </div>

      {/* Scrollable content area */}
      <div className="flex-1 overflow-y-auto mt-4">
        <div className="space-y-4">
          <h4 className="font-medium text-gray-700">Components:</h4>
          {page.components && page.components.length > 0 ? (
            <div className="space-y-4 bg-gray-50 rounded-lg border p-4">
              {renderPageComponents(page.components, 0, {}, {})}
            </div>
          ) : (
            <p className="text-gray-500 italic">No components in this page</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PagePreview;
